import React from "react";
import {FooterText, StyledFooter} from "./Footer.styles";

const Footer = () => {
    return (<StyledFooter>
        <FooterText>toDO. App developed by Ernest Bieś 2021 &copy; All rights reserved.</FooterText>
    </StyledFooter>);
};

export default Footer;
